export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["RESERVED"] = "RESERVED";
    PaymentStatus["EXECUTED"] = "EXECUTED";
    PaymentStatus["REVERTED"] = "REVERTED";
})(PaymentStatus || (PaymentStatus = {}));
